export const options = [
    {
        id: 0,
        value: 'series',
        title: 'Séries',
        parameter: 'titleStartsWith',
    },
    {
        id: 1,
        value: 'characters',
        title: 'Personagens',
        parameter: 'nameStartsWith',
        default: true,
    },
    {
        id: 2,
        value: 'comics',
        title: 'Quadrinhos',
        parameter: 'titleStartsWith',
    },
    {
        id: 3,
        value: 'events',
        title: 'Eventos',
        parameter: 'nameStartsWith',
    },
    {
        id: 4,
        value: 'stories',
        title: 'Histórias',
        parameter: 'titleStartsWith',
    },
];
